/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import { helpDialogMessages as messages } from '@atlaskit/editor-common/messages';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import Heading from '@atlaskit/heading';
import CloseIcon from '@atlaskit/icon/core/migration/close--cross';
import { header, toolbarButton } from './styles';
var ModalHeader = injectIntl(function (_ref) {
  var formatMessage = _ref.intl.formatMessage,
    onClose = _ref.onClose;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: header
    }, jsx(Heading, {
      size: "large"
    }, jsx(FormattedMessage, messages.editorHelp)), jsx("div", null, jsx(ToolbarButton
    // @ts-expect-error modal onClose handler requires second parameter of UIAnalyticsEvent, which we don't want to pass
    , {
      onClick: onClose,
      title: formatMessage(messages.closeHelpDialog),
      spacing: "compact",
      iconBefore: jsx(CloseIcon, {
        label: formatMessage(messages.closeHelpDialog),
        color: "currentColor",
        spacing: "spacious"
      })
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ,
      css: toolbarButton
    })))
  );
});
export default ModalHeader;